/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConsentFilesResponse,
  ConsentRequirementStatusResponse,
  ConsentResponse,
  ConsentScanUploadTicketResponse,
  ConsentScanUploadUrlDto,
  ConsentSignLinkResponse,
  ConsentSignLinkSentResponse,
  ConsentsList200,
  ConsentsListParams,
  ConsentsRenderParams,
  ConsentsRequirementStatusParams,
  ConsentsSessionStatusParams,
  CreateScanConsentDto,
  IssueConsentSignLinkDto,
  RenderedConsentResponse,
  SessionConsentStatusResponse,
  SignConsentDto,
  VoidConsentDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * به‌صورت پیش‌فرض فقط رضایت‌نامه‌های معتبر (امضاشده) برمی‌گردد؛ برای دیدن موارد باطل‌شده includeVoided=true بدهید.
 * @summary فهرست رضایت‌نامه‌ها
 */
export const consentsList = (
    params?: ConsentsListParams,
 signal?: AbortSignal
) => {


      return apiClient<ConsentsList200>(
      {url: `/api/v1/consents`, method: 'GET',
        params, signal
    },
      );
    }




export const getConsentsListQueryKey = (params?: ConsentsListParams,) => {
    return [
    `/api/v1/consents`, ...(params ? [params] : [])
    ] as const;
    }


export const getConsentsListQueryOptions = <TData = Awaited<ReturnType<typeof consentsList>>, TError = void>(params?: ConsentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof consentsList>>> = ({ signal }) => consentsList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConsentsListQueryResult = NonNullable<Awaited<ReturnType<typeof consentsList>>>
export type ConsentsListQueryError = void


export function useConsentsList<TData = Awaited<ReturnType<typeof consentsList>>, TError = void>(
 params: undefined |  ConsentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentsList>>,
          TError,
          Awaited<ReturnType<typeof consentsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsentsList<TData = Awaited<ReturnType<typeof consentsList>>, TError = void>(
 params?: ConsentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentsList>>,
          TError,
          Awaited<ReturnType<typeof consentsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsentsList<TData = Awaited<ReturnType<typeof consentsList>>, TError = void>(
 params?: ConsentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست رضایت‌نامه‌ها
 */

export function useConsentsList<TData = Awaited<ReturnType<typeof consentsList>>, TError = void>(
 params?: ConsentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConsentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * امضای گرفته‌شده روی تبلت کلینیک را ثبت می‌کند: تصویر امضا، بندهای تأییدشده، نام و نسبت امضاکننده، IP و دستگاه. سپس PDF فارسی ساخته و در فضای خصوصی ذخیره می‌شود.
 * @summary ثبت امضای الکترونیکی
 */
export const consentsSign = (
    signConsentDto: SignConsentDto,
 signal?: AbortSignal
) => {


      return apiClient<ConsentResponse>(
      {url: `/api/v1/consents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signConsentDto, signal
    },
      );
    }




export const getConsentsSignMutationKey = () => ['consentsSign'] as const;

export const getConsentsSignMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsSign>>, TError,ConsentsSignMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consentsSign>>, TError,ConsentsSignMutationVariables, TContext> => {

const mutationKey = getConsentsSignMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consentsSign>>, ConsentsSignMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  consentsSign(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConsentsSignMutationResult = NonNullable<Awaited<ReturnType<typeof consentsSign>>>
    export type ConsentsSignMutationBody = SignConsentDto
    export type ConsentsSignMutationError = void
    export type ConsentsSignMutationVariables = {data: SignConsentDto}

    /**
 * @summary ثبت امضای الکترونیکی
 */
export const useConsentsSign = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsSign>>, TError,ConsentsSignMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof consentsSign>>,
        TError,
        ConsentsSignMutationVariables,
        TContext
      > => {
      return useMutation(getConsentsSignMutationOptions(options), queryClient);
    }
    /**
 * قالب را برای این بیمار و این خدمت آماده می‌کند: متغیرها جایگزین می‌شوند و بندهای تأیید برمی‌گردند. همین متن است که در PDF چاپ می‌شود.
 * @summary پیش‌نمایش رضایت‌نامه برای یک بیمار
 */
export const consentsRender = (
    params: ConsentsRenderParams,
 signal?: AbortSignal
) => {


      return apiClient<RenderedConsentResponse>(
      {url: `/api/v1/consents/render`, method: 'GET',
        params, signal
    },
      );
    }




export const getConsentsRenderQueryKey = (params?: ConsentsRenderParams,) => {
    return [
    `/api/v1/consents/render`, ...(params ? [params] : [])
    ] as const;
    }


export const getConsentsRenderQueryOptions = <TData = Awaited<ReturnType<typeof consentsRender>>, TError = void>(params: ConsentsRenderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsRender>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsentsRenderQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof consentsRender>>> = ({ signal }) => consentsRender(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consentsRender>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConsentsRenderQueryResult = NonNullable<Awaited<ReturnType<typeof consentsRender>>>
export type ConsentsRenderQueryError = void


export function useConsentsRender<TData = Awaited<ReturnType<typeof consentsRender>>, TError = void>(
 params: ConsentsRenderParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsRender>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentsRender>>,
          TError,
          Awaited<ReturnType<typeof consentsRender>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsentsRender<TData = Awaited<ReturnType<typeof consentsRender>>, TError = void>(
 params: ConsentsRenderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsRender>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentsRender>>,
          TError,
          Awaited<ReturnType<typeof consentsRender>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsentsRender<TData = Awaited<ReturnType<typeof consentsRender>>, TError = void>(
 params: ConsentsRenderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsRender>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary پیش‌نمایش رضایت‌نامه برای یک بیمار
 */

export function useConsentsRender<TData = Awaited<ReturnType<typeof consentsRender>>, TError = void>(
 params: ConsentsRenderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsRender>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConsentsRenderQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * همان بررسی‌ای که هنگام نهایی کردن خدمت اجرا می‌شود. پنل با این پاسخ تصمیم می‌گیرد دکمهٔ «ثبت رضایت‌نامه» را نشان بدهد یا نه.
 * @summary وضعیت رضایت‌نامهٔ یک خدمت
 */
export const consentsSessionStatus = (
    params: ConsentsSessionStatusParams,
 signal?: AbortSignal
) => {


      return apiClient<SessionConsentStatusResponse>(
      {url: `/api/v1/consents/session-status`, method: 'GET',
        params, signal
    },
      );
    }




export const getConsentsSessionStatusQueryKey = (params?: ConsentsSessionStatusParams,) => {
    return [
    `/api/v1/consents/session-status`, ...(params ? [params] : [])
    ] as const;
    }


export const getConsentsSessionStatusQueryOptions = <TData = Awaited<ReturnType<typeof consentsSessionStatus>>, TError = void>(params: ConsentsSessionStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsSessionStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsentsSessionStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof consentsSessionStatus>>> = ({ signal }) => consentsSessionStatus(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consentsSessionStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConsentsSessionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof consentsSessionStatus>>>
export type ConsentsSessionStatusQueryError = void


export function useConsentsSessionStatus<TData = Awaited<ReturnType<typeof consentsSessionStatus>>, TError = void>(
 params: ConsentsSessionStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsSessionStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentsSessionStatus>>,
          TError,
          Awaited<ReturnType<typeof consentsSessionStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsentsSessionStatus<TData = Awaited<ReturnType<typeof consentsSessionStatus>>, TError = void>(
 params: ConsentsSessionStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsSessionStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentsSessionStatus>>,
          TError,
          Awaited<ReturnType<typeof consentsSessionStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsentsSessionStatus<TData = Awaited<ReturnType<typeof consentsSessionStatus>>, TError = void>(
 params: ConsentsSessionStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsSessionStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت رضایت‌نامهٔ یک خدمت
 */

export function useConsentsSessionStatus<TData = Awaited<ReturnType<typeof consentsSessionStatus>>, TError = void>(
 params: ConsentsSessionStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsSessionStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConsentsSessionStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * همان بررسی‌ای که هنگام ثبت جلسه با وضعیت «انجام شد» اجرا می‌شود. satisfied=true یعنی جلسه را می‌توان همین حالا «انجام شد» ثبت کرد.
 * @summary وضعیت رضایت‌نامهٔ یک بیمار برای یک خدمت، پیش از ثبت جلسه
 */
export const consentsRequirementStatus = (
    params: ConsentsRequirementStatusParams,
 signal?: AbortSignal
) => {


      return apiClient<ConsentRequirementStatusResponse>(
      {url: `/api/v1/consents/requirement-status`, method: 'GET',
        params, signal
    },
      );
    }




export const getConsentsRequirementStatusQueryKey = (params?: ConsentsRequirementStatusParams,) => {
    return [
    `/api/v1/consents/requirement-status`, ...(params ? [params] : [])
    ] as const;
    }


export const getConsentsRequirementStatusQueryOptions = <TData = Awaited<ReturnType<typeof consentsRequirementStatus>>, TError = void>(params: ConsentsRequirementStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsRequirementStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsentsRequirementStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof consentsRequirementStatus>>> = ({ signal }) => consentsRequirementStatus(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consentsRequirementStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConsentsRequirementStatusQueryResult = NonNullable<Awaited<ReturnType<typeof consentsRequirementStatus>>>
export type ConsentsRequirementStatusQueryError = void


export function useConsentsRequirementStatus<TData = Awaited<ReturnType<typeof consentsRequirementStatus>>, TError = void>(
 params: ConsentsRequirementStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsRequirementStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentsRequirementStatus>>,
          TError,
          Awaited<ReturnType<typeof consentsRequirementStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsentsRequirementStatus<TData = Awaited<ReturnType<typeof consentsRequirementStatus>>, TError = void>(
 params: ConsentsRequirementStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsRequirementStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentsRequirementStatus>>,
          TError,
          Awaited<ReturnType<typeof consentsRequirementStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsentsRequirementStatus<TData = Awaited<ReturnType<typeof consentsRequirementStatus>>, TError = void>(
 params: ConsentsRequirementStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsRequirementStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت رضایت‌نامهٔ یک بیمار برای یک خدمت، پیش از ثبت جلسه
 */

export function useConsentsRequirementStatus<TData = Awaited<ReturnType<typeof consentsRequirementStatus>>, TError = void>(
 params: ConsentsRequirementStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsRequirementStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConsentsRequirementStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary یک رضایت‌نامه
 */
export const consentsGet = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<ConsentResponse>(
      {url: `/api/v1/consents/${id}`, method: 'GET', signal
    },
      );
    }




export const getConsentsGetQueryKey = (id: string,) => {
    return [
    `/api/v1/consents/${id}`
    ] as const;
    }


export const getConsentsGetQueryOptions = <TData = Awaited<ReturnType<typeof consentsGet>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsentsGetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof consentsGet>>> = ({ signal }) => consentsGet(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consentsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConsentsGetQueryResult = NonNullable<Awaited<ReturnType<typeof consentsGet>>>
export type ConsentsGetQueryError = void


export function useConsentsGet<TData = Awaited<ReturnType<typeof consentsGet>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentsGet>>,
          TError,
          Awaited<ReturnType<typeof consentsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsentsGet<TData = Awaited<ReturnType<typeof consentsGet>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentsGet>>,
          TError,
          Awaited<ReturnType<typeof consentsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsentsGet<TData = Awaited<ReturnType<typeof consentsGet>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary یک رضایت‌نامه
 */

export function useConsentsGet<TData = Awaited<ReturnType<typeof consentsGet>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConsentsGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * لینک‌های امضاشدهٔ کوتاه‌عمر. سطل ذخیره‌سازی خصوصی است و هیچ نشانی دائمی برای این فایل‌ها وجود ندارد.
 * @summary لینک دانلود PDF و اسکن‌ها
 */
export const consentsFiles = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<ConsentFilesResponse>(
      {url: `/api/v1/consents/${id}/files`, method: 'GET', signal
    },
      );
    }




export const getConsentsFilesQueryKey = (id: string,) => {
    return [
    `/api/v1/consents/${id}/files`
    ] as const;
    }


export const getConsentsFilesQueryOptions = <TData = Awaited<ReturnType<typeof consentsFiles>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsFiles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsentsFilesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof consentsFiles>>> = ({ signal }) => consentsFiles(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consentsFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConsentsFilesQueryResult = NonNullable<Awaited<ReturnType<typeof consentsFiles>>>
export type ConsentsFilesQueryError = void


export function useConsentsFiles<TData = Awaited<ReturnType<typeof consentsFiles>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentsFiles>>,
          TError,
          Awaited<ReturnType<typeof consentsFiles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsentsFiles<TData = Awaited<ReturnType<typeof consentsFiles>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentsFiles>>,
          TError,
          Awaited<ReturnType<typeof consentsFiles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsentsFiles<TData = Awaited<ReturnType<typeof consentsFiles>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsFiles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لینک دانلود PDF و اسکن‌ها
 */

export function useConsentsFiles<TData = Awaited<ReturnType<typeof consentsFiles>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentsFiles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConsentsFilesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * یک نشانی امضاشدهٔ PUT برای بارگذاری مستقیم از مرورگر می‌سازد. مسیر فایل همیشه در سرور ساخته می‌شود و زیر پیشوند همین کلینیک قرار می‌گیرد؛ نوع فایل در امضا قفل می‌شود. پس از پایان بارگذاری، کلید برگشتی را به POST /consents/scan بدهید.
 * @summary لینک بارگذاری فرم کاغذی اسکن‌شده
 */
export const consentsScanUploadUrl = (
    consentScanUploadUrlDto: ConsentScanUploadUrlDto,
 signal?: AbortSignal
) => {


      return apiClient<ConsentScanUploadTicketResponse>(
      {url: `/api/v1/consents/scan-upload-url`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: consentScanUploadUrlDto, signal
    },
      );
    }




export const getConsentsScanUploadUrlMutationKey = () => ['consentsScanUploadUrl'] as const;

export const getConsentsScanUploadUrlMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsScanUploadUrl>>, TError,ConsentsScanUploadUrlMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consentsScanUploadUrl>>, TError,ConsentsScanUploadUrlMutationVariables, TContext> => {

const mutationKey = getConsentsScanUploadUrlMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consentsScanUploadUrl>>, ConsentsScanUploadUrlMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  consentsScanUploadUrl(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConsentsScanUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof consentsScanUploadUrl>>>
    export type ConsentsScanUploadUrlMutationBody = ConsentScanUploadUrlDto
    export type ConsentsScanUploadUrlMutationError = void
    export type ConsentsScanUploadUrlMutationVariables = {data: ConsentScanUploadUrlDto}

    /**
 * @summary لینک بارگذاری فرم کاغذی اسکن‌شده
 */
export const useConsentsScanUploadUrl = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsScanUploadUrl>>, TError,ConsentsScanUploadUrlMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof consentsScanUploadUrl>>,
        TError,
        ConsentsScanUploadUrlMutationVariables,
        TContext
      > => {
      return useMutation(getConsentsScanUploadUrlMutationOptions(options), queryClient);
    }
    /**
 * برای بیمارانی که فرم چاپی را امضا کرده‌اند. فایل‌ها را ابتدا با لینک امضاشدهٔ بارگذاری بفرستید و کلیدشان را اینجا بدهید؛ کلیدهایی که به این کلینیک تعلق ندارند رد می‌شوند.
 * @summary ثبت فرم کاغذی اسکن‌شده
 */
export const consentsAttachScan = (
    createScanConsentDto: CreateScanConsentDto,
 signal?: AbortSignal
) => {


      return apiClient<ConsentResponse>(
      {url: `/api/v1/consents/scan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createScanConsentDto, signal
    },
      );
    }




export const getConsentsAttachScanMutationKey = () => ['consentsAttachScan'] as const;

export const getConsentsAttachScanMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsAttachScan>>, TError,ConsentsAttachScanMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consentsAttachScan>>, TError,ConsentsAttachScanMutationVariables, TContext> => {

const mutationKey = getConsentsAttachScanMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consentsAttachScan>>, ConsentsAttachScanMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  consentsAttachScan(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConsentsAttachScanMutationResult = NonNullable<Awaited<ReturnType<typeof consentsAttachScan>>>
    export type ConsentsAttachScanMutationBody = CreateScanConsentDto
    export type ConsentsAttachScanMutationError = void
    export type ConsentsAttachScanMutationVariables = {data: CreateScanConsentDto}

    /**
 * @summary ثبت فرم کاغذی اسکن‌شده
 */
export const useConsentsAttachScan = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsAttachScan>>, TError,ConsentsAttachScanMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof consentsAttachScan>>,
        TError,
        ConsentsAttachScanMutationVariables,
        TContext
      > => {
      return useMutation(getConsentsAttachScanMutationOptions(options), queryClient);
    }
    /**
 * یک لینک یک‌بارمصرف و زمان‌دار می‌سازد تا بیمار پیش از مراجعه، از گوشی خودش امضا کند. نسخهٔ قالب همین حالا قفل می‌شود، پس انتشار نسخهٔ تازه، سندی را که برای بیمار فرستاده‌اید عوض نمی‌کند. ارسال پیامک برعهدهٔ ماژول اطلاع‌رسانی است؛ اینجا فقط نشانی برگردانده می‌شود.
 * @summary ساخت لینک امضا برای بیمار
 */
export const consentsIssueSignLink = (
    issueConsentSignLinkDto: IssueConsentSignLinkDto,
 signal?: AbortSignal
) => {


      return apiClient<ConsentSignLinkResponse>(
      {url: `/api/v1/consents/sign-links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: issueConsentSignLinkDto, signal
    },
      );
    }




export const getConsentsIssueSignLinkMutationKey = () => ['consentsIssueSignLink'] as const;

export const getConsentsIssueSignLinkMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsIssueSignLink>>, TError,ConsentsIssueSignLinkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consentsIssueSignLink>>, TError,ConsentsIssueSignLinkMutationVariables, TContext> => {

const mutationKey = getConsentsIssueSignLinkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consentsIssueSignLink>>, ConsentsIssueSignLinkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  consentsIssueSignLink(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConsentsIssueSignLinkMutationResult = NonNullable<Awaited<ReturnType<typeof consentsIssueSignLink>>>
    export type ConsentsIssueSignLinkMutationBody = IssueConsentSignLinkDto
    export type ConsentsIssueSignLinkMutationError = void
    export type ConsentsIssueSignLinkMutationVariables = {data: IssueConsentSignLinkDto}

    /**
 * @summary ساخت لینک امضا برای بیمار
 */
export const useConsentsIssueSignLink = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsIssueSignLink>>, TError,ConsentsIssueSignLinkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof consentsIssueSignLink>>,
        TError,
        ConsentsIssueSignLinkMutationVariables,
        TContext
      > => {
      return useMutation(getConsentsIssueSignLinkMutationOptions(options), queryClient);
    }
    /**
 * همان لینک یک‌بارمصرف را می‌سازد و از طریق ماژول اطلاع‌رسانی — با کسر از اعتبار پیامک کلینیک، رعایت ساعات سکوت و ثبت در گزارش پیام‌ها — به شمارهٔ ثبت‌شدهٔ بیمار می‌فرستد. لینک در پاسخ برمی‌گردد تا اگر پیامک ارسال نشد (اعتبار ناکافی، ساعات سکوت) بتوان آن را دستی هم داد. شمارهٔ بیمار هرگز در پاسخ نیست. بیمار محدودشده پذیرفته نمی‌شود؛ لغو پیامک تبلیغاتی مانع ارسال رضایت‌نامه نیست.
 * @summary ساخت لینک امضا و پیامک آن به بیمار
 */
export const consentsSendSignLink = (
    issueConsentSignLinkDto: IssueConsentSignLinkDto,
 signal?: AbortSignal
) => {


      return apiClient<ConsentSignLinkSentResponse>(
      {url: `/api/v1/consents/sign-links/send`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: issueConsentSignLinkDto, signal
    },
      );
    }




export const getConsentsSendSignLinkMutationKey = () => ['consentsSendSignLink'] as const;

export const getConsentsSendSignLinkMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsSendSignLink>>, TError,ConsentsSendSignLinkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consentsSendSignLink>>, TError,ConsentsSendSignLinkMutationVariables, TContext> => {

const mutationKey = getConsentsSendSignLinkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consentsSendSignLink>>, ConsentsSendSignLinkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  consentsSendSignLink(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConsentsSendSignLinkMutationResult = NonNullable<Awaited<ReturnType<typeof consentsSendSignLink>>>
    export type ConsentsSendSignLinkMutationBody = IssueConsentSignLinkDto
    export type ConsentsSendSignLinkMutationError = void
    export type ConsentsSendSignLinkMutationVariables = {data: IssueConsentSignLinkDto}

    /**
 * @summary ساخت لینک امضا و پیامک آن به بیمار
 */
export const useConsentsSendSignLink = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsSendSignLink>>, TError,ConsentsSendSignLinkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof consentsSendSignLink>>,
        TError,
        ConsentsSendSignLinkMutationVariables,
        TContext
      > => {
      return useMutation(getConsentsSendSignLinkMutationOptions(options), queryClient);
    }
    /**
 * رضایت‌نامه حذف نمی‌شود؛ وضعیتش به «باطل‌شده» تغییر می‌کند و دلیل، زمان و کاربر ثبت و در گزارش ممیزی درج می‌شود. خدمتی که به آن وابسته است تا ثبت رضایت‌نامهٔ تازه نهایی نمی‌شود.
 * @summary ابطال رضایت‌نامه
 */
export const consentsVoid = (
    id: string,
    voidConsentDto: VoidConsentDto,
 signal?: AbortSignal
) => {


      return apiClient<ConsentResponse>(
      {url: `/api/v1/consents/${id}/void`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: voidConsentDto, signal
    },
      );
    }




export const getConsentsVoidMutationKey = () => ['consentsVoid'] as const;

export const getConsentsVoidMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsVoid>>, TError,ConsentsVoidMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consentsVoid>>, TError,ConsentsVoidMutationVariables, TContext> => {

const mutationKey = getConsentsVoidMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consentsVoid>>, ConsentsVoidMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  consentsVoid(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConsentsVoidMutationResult = NonNullable<Awaited<ReturnType<typeof consentsVoid>>>
    export type ConsentsVoidMutationBody = VoidConsentDto
    export type ConsentsVoidMutationError = void
    export type ConsentsVoidMutationVariables = {id: string;data: VoidConsentDto}

    /**
 * @summary ابطال رضایت‌نامه
 */
export const useConsentsVoid = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsVoid>>, TError,ConsentsVoidMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof consentsVoid>>,
        TError,
        ConsentsVoidMutationVariables,
        TContext
      > => {
      return useMutation(getConsentsVoidMutationOptions(options), queryClient);
    }
    /**
 * اگر رضایت‌نامهٔ لازم موجود نباشد با ۴۲۲ و کد TREATMENT_CONSENT_REQUIRED رد می‌شود. همین بررسی هنگام تغییر وضعیت خدمت به «انجام‌شده» هم اجرا می‌شود؛ این مسیر برای پیش‌بررسی در پنل است.
 * @summary بررسی مجاز بودن نهایی کردن خدمت
 */
export const consentsAssertSession = (
    sessionId: string,
 signal?: AbortSignal
) => {


      return apiClient<SessionConsentStatusResponse>(
      {url: `/api/v1/consents/sessions/${sessionId}/assert`, method: 'POST', signal
    },
      );
    }




export const getConsentsAssertSessionMutationKey = () => ['consentsAssertSession'] as const;

export const getConsentsAssertSessionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsAssertSession>>, TError,ConsentsAssertSessionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consentsAssertSession>>, TError,ConsentsAssertSessionMutationVariables, TContext> => {

const mutationKey = getConsentsAssertSessionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consentsAssertSession>>, ConsentsAssertSessionMutationVariables> = (props) => {
          const {sessionId} = props ?? {};

          return  consentsAssertSession(sessionId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConsentsAssertSessionMutationResult = NonNullable<Awaited<ReturnType<typeof consentsAssertSession>>>

    export type ConsentsAssertSessionMutationError = void
    export type ConsentsAssertSessionMutationVariables = {sessionId: string}

    /**
 * @summary بررسی مجاز بودن نهایی کردن خدمت
 */
export const useConsentsAssertSession = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentsAssertSession>>, TError,ConsentsAssertSessionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof consentsAssertSession>>,
        TError,
        ConsentsAssertSessionMutationVariables,
        TContext
      > => {
      return useMutation(getConsentsAssertSessionMutationOptions(options), queryClient);
    }
